module.exports = __webpack_public_path__ + "img/brand.4f86e4bb.svg";